import React, { useState } from 'react';
import MainLayout from '../components/layout/MainLayout';
import Section from '../components/ui/Section';
import Button from '../components/ui/Button';
import supabase from '../supabase/supabase';

const Contact = () => {
  const [status, setStatus] = useState('idle');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const discoveryLink = "https://tidycal.com/1x8odpm/ai-discovery-call-1y6rlrd";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    
    try {
      const { error } = await supabase
        .from('contact_submissions_1779580000000')
        .insert([formData]);

      if (error) throw error;
      setStatus('success');
    } catch (err) {
      console.error('Contact error:', err);
      setStatus('error');
    }
  };

  return (
    <MainLayout>
      <Section bg="white" className="pt-20">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row gap-16">
          <div className="w-full md:w-1/2">
            <h1 className="text-4xl font-bold text-brand-navy mb-6">Let's talk.</h1>
            <p className="text-lg text-gray-600 mb-8">
              Whether you need to inquire about team training or have a specific question, we're here to help.
            </p>
            
            <div className="bg-brand-teal/5 p-8 rounded-2xl border border-brand-teal/20">
              <h3 className="font-bold text-brand-navy text-xl mb-2">Want to skip the form?</h3>
              <p className="text-gray-600 mb-6">Book a 20-minute discovery call directly into my calendar.</p>
              <Button href={discoveryLink} variant="primary" className="text-sm">
                Book Discovery Call
              </Button>
            </div>
          </div>

          <div className="w-full md:w-1/2">
            {status === 'success' ? (
              <div className="bg-brand-cream p-12 rounded-2xl border border-gray-200 text-center animate-fade-in">
                <h3 className="text-2xl font-bold text-brand-navy mb-2">Message sent.</h3>
                <p className="text-gray-600">We'll get back to you within 2 working days.</p>
                <Button onClick={() => setStatus('idle')} variant="ghost" className="mt-4">
                  Send another message
                </Button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6 bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                  <input
                    type="text"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full p-3 rounded-md border border-gray-300 focus:ring-brand-teal focus:border-brand-teal"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full p-3 rounded-md border border-gray-300 focus:ring-brand-teal focus:border-brand-teal"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">How can we help?</label>
                  <textarea
                    required
                    rows="4"
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    className="w-full p-3 rounded-md border border-gray-300 focus:ring-brand-teal focus:border-brand-teal"
                  ></textarea>
                </div>

                {status === 'error' && <p className="text-red-600 text-sm">Failed to send. Please try again.</p>}

                <Button type="submit" variant="primary" fullWidth disabled={status === 'submitting'}>
                  {status === 'submitting' ? 'Sending...' : 'Send Message'}
                </Button>
              </form>
            )}
          </div>
        </div>
      </Section>
    </MainLayout>
  );
};

export default Contact;